import User from "@views/user/User";

export default [
  {
    path: "/user",
    name: "User",
    meta: {
      title: "个人中心",
      keepAlive: false,
      footer: true,
      auth: true
    },
    component: User
  },
  {
    path: "/user/binding",
    name: "BindingPhone",
    meta: {
      title: "绑定手机",
      keepAlive: false,
      backgroundColor: "#fff",
      auth: true
    },
    component: () => import("@views/user/BindingPhone.vue")
  },
  {
    path: "/user/exchange",
    name: "exchange",
    meta: {
      title: "佣金转账",
      keepAlive: false,
      backgroundColor: "#fff",
      auth: true
    },
    component: () => import("@views/user/exchange.vue")
  },
  {
    path: "/user/exchange1",
    name: "exchange1",
    meta: {
      title: "佣金转余额",
      keepAlive: false,
      backgroundColor: "#fff",
      auth: true
    },
    component: () => import("@views/user/exchange1.vue")
  },
  {
    path: "/user/exchange2",
    name: "exchange1",
    meta: {
      title: "爱心积分转换",
      keepAlive: false,
      backgroundColor: "#fff",
      auth: true
    },
    component: () => import("@views/user/exchange2.vue")
  },
  {
    path: "/user/exchange3",
    name: "exchange3",
    meta: {
      title: "动力积分转换",
      keepAlive: false,
      backgroundColor: "#fff",
      auth: true
    },
    component: () => import("@views/user/exchange3.vue")
  },
  {
    path: "/user/exchange4",
    name: "exchange4",
    meta: {
      title: "生态值转入推荐单",
      keepAlive: false,
      backgroundColor: "#fff",
      auth: true
    },
    component: () => import("@views/user/exchange4.vue")
  },
  {
    path: "/user/add_address/:id?",
    name: "AddAddress",
    meta: {
      title: "添加收货地址",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/user/address/AddAddress.vue")
  },
  {
    path: "/user/water",
    name: "water",
    meta: {
      title: "收集水滴",
      keepAlive: false,
      footer: true,
      auth: true
    },
    component: () => import("@views/user/water.vue")
  },
  {
    path: "/user/warehouse",
    name: "water",
    meta: {
      title: "云仓商品列表",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/user/warehouse.vue")
  },
  {
    path: "/user/warehouse2",
    name: "water2",
    meta: {
      title: "云仓商品列表",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/user/warehouse2.vue")
  },
  {
    path: "/user/record",
    name: "record",
    meta: {
      title: "转账记录",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/user/record.vue")
  },
  {
    path: "/user/ranking",
    name: "ranking",
    meta: {
      title: "排行榜",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/user/rank.vue")
  },
  {
    path: "/user/stocklog/:id/:type",
    name: "stocklog",
    meta: {
      title: "库存记录",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/user/stocklog.vue")
  },
  {
    path: "/user/stockdetail/:id/:type",
    name: "stockdetail",
    meta: {
      title: "云仓商品列表",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/user/stockdetail.vue")
  },
  {
    path: "/user/account",
    name: "UserAccount",
    meta: {
      title: "我的账户",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/user/UserAccount.vue")
  },
  {
    path: "/user/add_manage",
    name: "AddressManagement",
    meta: {
      title: "地址管理",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/user/address/AddressManagement.vue")
  },
  {
    path: "/user/poster",
    name: "Poster",
    meta: {
      title: "分销海报",
      keepAlive: false,
      backgroundColor: "#a3a3a3",
      auth: true
    },
    component: () => import("@views/user/promotion/Poster.vue")
  },
  {
    path: "/user/sign",
    name: "Sign",
    meta: {
      title: "签到",
      keepAlive: false,
      auth: true,
      footer: true
    },
    component: () => import("@views/user/signIn/Sign.vue")
  },
  {
    path: "/user/sign_record",
    name: "SignRecord",
    meta: {
      title: "签到记录",
      keepAlive: true
    },
    component: () => import("@views/user/signIn/SignRecord.vue")
  },
  {
    path: "/user/cash",
    name: "UserCash",
    meta: {
      title: "提现",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/user/promotion/UserCash.vue")
  },
  {
    path: "/user/audit",
    name: "CashAudit",
    meta: {
      title: "提现审核",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/user/promotion/CashAudit.vue")
  },
  {
    path: "/user/promoter_order",
    name: "PromoterOrder",
    meta: {
      title: "推广人订单",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/user/promotion/PromoterOrder.vue")
  },
  {
    path: "/user/promoter_list",
    name: "PromoterList",
    meta: {
      title: "推广人列表",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/user/promotion/PromoterList.vue")
  },
  {
    path: "/user/user_promotion",
    name: "UserPromotion",
    meta: {
      title: "我的推广",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/user/promotion/UserPromotion.vue")
  },
  {
    path: "/user/bill/:types?",
    name: "UserBill",
    meta: {
      title: "账单明细",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/user/UserBill.vue")
  },
  {
    path: "/user/cashrecord",
    name: "CashRecord",
    meta: {
      title: "提现记录",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/user/promotion/CashRecord.vue")
  },
  {
    path: "/user/commission",
    name: "CommissionDetails",
    meta: {
      title: "佣金明细",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/user/promotion/CommissionDetails.vue")
  },
  {
    path: "/user/integral",
    name: "Integral",
    meta: {
      title: "积分详情",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/user/signIn/Integral.vue")
  },
  {
    path: "/user/integral2",
    name: "Integral",
    meta: {
      title: "数据详情",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/user/signIn/Integral2.vue")
  },
  {
    path: "/user/kong",
    name: "kong",
    meta: {
      title: "信息详情",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/user/kong.vue")
  },
  {
    path: "/user/love",
    name: "love",
    meta: {
      title: "生态值详情",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/user/love.vue")
  },
  {
    path: "/user/combination",
    name: "combination",
    meta: {
      title: "我的积分",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/user/combination.vue")
  },
  {
    path: "/user/combination2",
    name: "combination2",
    meta: {
      title: "业绩信息",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/user/combination2.vue")
  },
  {
    path: "/user/vip",
    name: "UserVip",
    meta: {
      title: "会员中心",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/user/UserVip.vue")
  },
  {
    path: "/user/data",
    name: "PersonalData",
    meta: {
      title: "个人资料",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/user/PersonalData.vue")
  },
  {
    path: "/user/user_coupon",
    name: "UserCoupon",
    meta: {
      title: "我的优惠券",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/user/coupon/UserCoupon.vue")
  },
  {
    path: "/user/get_coupon",
    name: "GetCoupon",
    meta: {
      title: "领取优惠券",
      keepAlive: true
    },
    component: () => import("@views/user/coupon/GetCoupon.vue")
  },
  {
    path: "/user/user_cash",
    name: "UserCash",
    meta: {
      title: "申请提现",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/user/promotion/UserCash.vue")
  },
  {
    path: "/customer/list/:productId?",
    name: "CustomerList",
    meta: {
      title: "客服列表",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/user/CustomerList.vue")
  },
  {
    path: "/user/Recharge",
    name: "Recharge",
    meta: {
      title: "余额充值",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/user/Recharge.vue")
  },
  {
    path: "/user/promoter_rank",
    name: "PromoterRank",
    meta: {
      title: "推广人排行",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/user/promotion/PromoterRank.vue")
  },
  {
    path: "/user/commission/rank",
    name: "CommissionRank",
    meta: {
      title: "佣金排行",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/user/promotion/CommissionRank.vue")
  },
  {
    path: "/orderAdmin/hxOrderLog",
    name: "hxOrderLog",
    meta: {
      title: "核销人员记录",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/orderAdmin/hxOrderLog.vue")
  },
  {
    path: "/orderAdmin/etcardinfo",
    name: "etcardinfo",
    meta: {
      title: "核销人员实名",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/orderAdmin/etcardinfo.vue")
  },
  {
    path: "/user/apply",
    name: "apply",
    meta: {
      title: "开户申请",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/user/apply.vue")
  },
  {
    path: "/user/apply2",
    name: "apply2",
    meta: {
      title: "完善课程个人信息",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/user/apply2.vue")
  },
  {
    path: "/user/apply3",
    name: "apply3",
    meta: {
      title: "门店申请",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/user/apply3.vue")
  },
  {
    path: "/user/apply4",
    name: "apply4",
    meta: {
      title: "团队长入网申请",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/user/apply4.vue")
  },
  {
    path: "/user/attestation",
    name: "attestation",
    meta: {
      title: "认证",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/user/attestation.vue")
  }
];
